import React, { useState } from "react";
import { copy } from "../text";
import Link from "./Link";

function Navbar() {
  const [scroll, _setScroll] = useState(window.scrollY);
  const setScroll = () => _setScroll(window.scrollY);

  React.useEffect(() => {
    window.addEventListener("scroll", setScroll);
    return () => {
      window.removeEventListener("scroll", setScroll);
    };
  }, []);

  return (
    <div
      style={{ height: "4rem" }}
      className={`z-50 px-12 h-16 w-full flex justify-center bg-primary ${
        scroll > 150
          ? "-top-16 fixed border-b translate-y-16 transition-transform duration-500"
          : "absolute"
      }`}
    >
      <div className="flex justify-between items-center w-full h-full max-w-7xl text-secondary">
        <div className="font-bold">{copy.companyName}</div>
        <div className="gap-4 hidden sm:flex">
          <div>
            <Link to="#home" label={copy.homeHeader} />
          </div>
          <div>
            <Link to="#testimonials" label={copy.ourWorkHeader} />
          </div>
          <Link to="#contact" label={copy.contactHeader} />
        </div>
      </div>
    </div>
  );
}

export default Navbar;
